import { useInstance } from '@meraki-internal/react-dependency-injection';
import { useSubscription } from '@meraki-internal/state';
import { CareMapState } from '../caremap/CareMapState';

// Bea answers about the care map the chat sends (the most recent one), which the api can withhold
// from a reader. A caregiver with no care map yet still meets Bea. Every Bea entry point
// (header button, home card, note bubble) decides through this one rule.
export const useCanChatWithBea = (): boolean => {
    const careMapState = useInstance(CareMapState);
    useSubscription(() => careMapState);

    const careMap = careMapState.getMostRecentCaremap();
    return !careMap || Boolean(careMap.links?.self?.actions?.includes('get-chat-context'));
};
